<template>
  <div class="main">
    <Sidebar
      :current-keywords="keywords"
      :current-filters="currentFilters"
      :filter-types="filterTypes"
      @search="setKeywords"
      @add-filter="addFilter"
      @remove-filter="removeFilter"
      @remove-all-filters="removeAllFilters"
    />

    <div class="title-bar">
      <a class="float-right btn btn-info" :href="route('admin.orders.create')">
        <span class="icon icon-plus"></span>
        <span class="text">Add New</span>
      </a>
      <h1>Orders</h1>
      <AdminMenu class="pt-2" current="Orders" />
    </div>

    <div class="content p-3">
      <div class="row">
        <div class="col-12">
          <transition name="fade">
            <Alert v-if="hasAlert" :alert="alert" />
          </transition>
          <div class="row">
            <div class="col-12">
              <ListTable
                :items="items"
                :columns="columns"
                :activeColumns="activeColumns"
                :hideNoResults="hideNoResults"
                @sort-by="setSort"
                @swap-column="setActiveColumn"
                @item-clicked="setSelectedItem"
              >
                <template
                  v-slot:col_event_start_date="{ item }"
                >{{ item.event_start_date | moment("MM/DD/YYYY") }}</template>
                <template
                  v-slot:col_shipped_at="{ item }"
                >{{ item.shipped_at | moment("MM/DD/YYYY") }}</template>
                <template v-slot:col_status="{ item }">{{ item.status_label }}</template>
                <template v-slot:col_shipment_carrier="{ item }">{{ item.shipment_carrier_label }}</template>
                <template
                  v-slot:col_will_ship_at="{ item }"
                >{{ item.will_ship_at | moment("MM/DD/YYYY") }}</template>
                <template
                  v-slot:col_arrived_at="{ item }"
                >{{ item.arrived_at | moment("MM/DD/YYYY") }}</template>
                <template v-slot:list-menu="{ item, id }">
                  <ListMenu :item="item" :id="id" :eventBus="listEvents" />
                </template>
              </ListTable>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-center col-xl-3 text-xl-left">
              <a class="btn btn-info" href="#" @click.prevent="showExportOptions()">
                <span class="icon icon-download"></span>
                <span class="text">Export List</span>
              </a>
            </div>
            <div class="col-12 col-xl-6 text-center">
              <Pagination
                class="d-inline-block"
                :total="totalPages"
                :value="parseInt(pagination.current)"
                @input="setCurrentPage"
              />
            </div>
            <div class="col-12 col-xl-3 text-center text-xl-right">
              <PageSize :value="parseInt(pagination.per_page)" @input="setPerPage" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import ListingMixin from "mixins/Listing";
import AdminMenu from "../partials/AdminMenu";
import ListMenu from "./partials/ListMenu";

export default {
  mixins: [DisplaysAlerts, ListingMixin],
  components: { AdminMenu, ListMenu },
  methods: {
    cancel(item) {},
    remove(item) {
      if (confirm(`Are you sure you would like to remove this order?`)) {
        this.axios
          .delete(this.route("admin.orders.destroy", { order: item.id }))
          .then(() => {
            this.refresh();
            this.showAlert("success", `The order has been removed`, true);
          });
      }
    },
    handleMenuAction(action, item) {
      if (action == "remove") {
        this.remove(item);
      } else if (action == "cancel") {
        this.cancel(item);
      }
    }
  },
  mounted() {
    this.listEvents.$on("menu-action", this.handleMenuAction);
  }
};
</script>
